<template>
  <div id="not-found">
    <div id="not-found__container">
      <h1 class="container__title">Stran ne obstaja.</h1>

      <div>
        <p class="not-found__subtext" style="margin-bottom: 50px">
          Tukaj nismo našli nič. <br/>
          Prosimo, da za dostop do vašega obrazca uporabite pravilno povezavo.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "not-found",
  mounted() {
    document.title = 'Stran ne obstaja - Triglav Zdravje';
  }
}
</script>

<style>
@media (min-width: 280px) {
  #not-found {
    min-height: 100vh;
    background: linear-gradient(93.81deg, #1ea89c 0%, #006c68 100%);
  }

  #not-found #not-found__container {
    padding: 1rem;
    max-width: 270px;
    margin: 0 auto;
  }

  #not-found #not-found__container .container__title {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 50px;
    text-align: center;
    letter-spacing: 2.5px;

    margin: 50px auto;
    color: #fafafa;
  }

  #not-found #not-found__container .not-found__subtext {
    font-family: "Open Sans";
    font-style: normal;
    font-size: 18px;
    line-height: 25px;
    text-align: center;

    color: #fafafa;
  }

  #not-found #not-found__container ul {
    margin-bottom: 50px;
  }

  #not-found #not-found__container ul li {
    text-align: left !important;
    margin: 15px 0;
  }

  #not-found #not-found__container ul li span:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

@media (min-width: 375px) {
  #not-found #not-found__container {
    max-width: 370px;
  }
}

@media (min-width: 768px) {
  #not-found #not-found__container {
    max-width: 663px;
  }
}
</style>
